import { useMutation } from '@cd/react-query';
import { postJSONPS, either } from '@cd/utils';
import { useStore } from './store';

export function useCreateSubscription({
	onSuccess: onSuccessFn,
	onError: onErrorFn
}) {
	const { dispatch } = useStore();
	const { mutate, onSuccess, ...rest } = useMutation(
		({ subscriptionData }) => {
			return postJSONPS('POST', '/subscription/create/subscription', {
				body: JSON.stringify({ subscriptionData })
			});
		},
		{
			onSuccess: value => {
				console.log('valuexzx', value);

				either(
					e => {
						onErrorFn(e);
						dispatch({ type: 'post error', e });
					},
					v => {
						onSuccessFn(v);
						return v;
					},
					value
				);

				//queryClient.invalidateQueries('');
			},
			onError: e => dispatch({ type: 'post error', e })
		}
	);

	return { mutate, ...rest };
}
